module.exports = __webpack_public_path__ + "img/bakTop.0d18b07a.png";